import { render, staticRenderFns } from "./SalSalesOrder.vue?vue&type=template&id=0c4eae9b&scoped=true&"
import script from "./SalSalesOrder.vue?vue&type=script&lang=js&"
export * from "./SalSalesOrder.vue?vue&type=script&lang=js&"
import style0 from "./SalSalesOrder.vue?vue&type=style&index=0&id=0c4eae9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4eae9b",
  null
  
)

export default component.exports